import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { usePaymentGatewayOptions } from "~/modules/Products/ProductForm/hooks/usePaymentGatewayOptions";
import { supabase } from "~/store/initializeStore";

export const ALL_PRODUCTS_ITEM_ID = "all";

const DEFAULT_GROUP_KEY = "__default__";
const DEFAULT_GROUP_LABEL = "Główne";

export const useProductsList = () => {
  const { stripeOptionsByKey } = usePaymentGatewayOptions();
  const { data, isLoading } = useQuery(["useProductsList"], {
    keepPreviousData: true,
    queryFn: async () => {
      const { data } = await supabase.from("product").select("id, name, customStripeAccount").throwOnError();

      return data;
    },
  });

  const flat = useMemo(() => (data || []).map((product) => ({ value: product.id, label: product.name })), [data]);

  const groupedList = useMemo(() => {
    const groups: Record<string, { label: string; options: { value: string; label: string }[] }> = {
      [DEFAULT_GROUP_KEY]: { label: DEFAULT_GROUP_LABEL, options: [] },
    };

    for (const product of data || []) {
      const stripeAcc = product.customStripeAccount ? stripeOptionsByKey[product.customStripeAccount] : undefined;
      const key =
        product.customStripeAccount && stripeAcc && !stripeAcc.isDefault
          ? product.customStripeAccount
          : DEFAULT_GROUP_KEY;

      if (!groups[key]) {
        groups[key] = { label: stripeAcc?.name ?? key, options: [] };
      }
      groups[key].options.push({ value: product.id, label: product.name });
    }

    return Object.values(groups).filter((group) => group.options.length > 0);
  }, [data, stripeOptionsByKey]);

  return {
    isLoading,
    productsList: [{ label: "Wszystkie produkty", value: ALL_PRODUCTS_ITEM_ID }, ...flat],
    list: flat,
    groupedList,
  };
};
